import pb from "@pb/index.json";
const ErrorAuthCode = pb.nested.yunpb.nested.ErrorAuthCode.values;

export default {
  errorMessage: function (rpcoutput: any) {
    if (rpcoutput) {
      if (rpcoutput.desc && rpcoutput.desc.length) {
        return rpcoutput.desc;
      }

      if (rpcoutput.ret !== 0) {
        return (
          "There is a little problem with the connection, chikii is sorry（" +
          rpcoutput.ret +
          ")"
        );
      }
    }

    return (
      "There is a little problem with the connection, chikii is sorry（" +
      this.CONST.clientError +
      ")"
    );
  },
  clientErrorMessage: function (ret: number) {
    return (
      "There is a little problem with the connection, chikii is sorry（" +
      ret +
      ")"
    );
  },
  CONST: {
    clientError: 20000,
    webrtcTimeout: 220001,
    switchGameError: 22002,
    createOfferError: 22003,
    sendChannelDataError: 22004,
    channelConnectError: 22005,
    answerError: 22006,
    webrtcFailed: 22007,
    webrtcNotifyError: 22008,
    websocketNotConnected: 22009,
    rpcinputParseError: 22110,
    rpcinputException: 22111,
  },
  shouldClearAccounts: function (ret: number) {
    if (
      ret === ErrorAuthCode.ErrorAuthSessionNotFound ||
      ret === ErrorAuthCode.ErrorAuthNeedLogin ||
      ret === ErrorAuthCode.ErrorAuthUserNotFound ||
      ret === ErrorAuthCode.ErrorAuthSessionTimeOut
    ) {
      return true;
    }

    return false;
  },
};
